import React, {useEffect, useState} from 'react';
import ReactGA from 'react-ga4';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { HashLink } from 'react-router-hash-link';
import MiaAbout from "../resources/images/mia_about.png";
import Logo from "../resources/images/logo.png";
import CharacterEdward from "../resources/images/character_edward.png";
import CharacterVictoria from "../resources/images/character_victoria.png";
import CharacterMia from "../resources/images/character_mia.png";
import CharacterNumber4 from "../resources/images/character_number4.png";
import CharacterHector from "../resources/images/character_hector.png";
import ReactPlayer from "react-player";
import TrailerImage from "../resources/images/trailer/trailer.jpg";

import AtomicAgeScreenshotDialogue1 from "../resources/images/screenshots/AtomicAgeScreenshotDialogue1.jpg";
import AtomicAgeScreenshotDialogue2 from "../resources/images/screenshots/AtomicAgeScreenshotDialogue2.jpg";
import AtomicAgeScreenshotInventory1 from "../resources/images/screenshots/AtomicAgeScreenshotInventory1.jpg";
import AtomicAgeScreenshotInventory2 from "../resources/images/screenshots/AtomicAgeScreenshotInventory2.jpg";
import AtomicAgeScreenshotObjectInteraction1 from "../resources/images/screenshots/AtomicAgeScreenshotObjectInteraction1.jpg";
import AtomicAgeScreenshotTitleScreen from "../resources/images/screenshots/AtomicAgeScreenshotTitleScreen.jpg";
import AtomicAgeScreenshotStage from "../resources/images/screenshots/AtomicAgeStageScreenshotMovement1.jpg";
import AtomicAgeMap from "../resources/images/screenshots/AtomicAgeMap.jpg";

import DesyTeam from "../resources/images/team/desy_small.jpg";
import ChrisTeam from "../resources/images/team/chris_small.jpg";
import JillTeam from "../resources/images/team/jill_small.jpg";
import StaffaTeam from "../resources/images/team/staffa_small.png";
import CameronTeam from "../resources/images/team/cameron_small.jpg";
import MaksTeam from "../resources/images/team/maks_small.jpg";

import Lightbox from "yet-another-react-lightbox";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import { ColumnsPhotoAlbum } from "react-photo-album";
import "react-photo-album/styles.css";
import SteamNews from "./steam";


const GoogleAnalyticsTrackingId = "G-565ZWJR7LT";
ReactGA.initialize(GoogleAnalyticsTrackingId);

const Header = () => {
    useEffect(() => {
        const navbar = document.querySelector(".navbar-collapse");
        const toggle: any = document.querySelector(".navbar-toggler");

        function closeNavbar() {
            if (navbar?.classList.contains("show")) {
                toggle?.click();
            }
        }

        const handleClickOutside = () => {
            if (navbar) {
                closeNavbar();
            }
        }

        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

  return (
      <div className="header-line-wrapper">
          <header className="header-wrapper fixed-top">
              <div className="box box--logo">
                  <a href="/#" className="z-1"><div className='logo' /></a>
                  <div style={{width: '74rem'}}/>
              </div>
              <nav className="navbar-expand-lg navbar-dark box box--nav z-3">
                  <div className="main-menu text-center">
                      <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                              data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                              aria-expanded="false" aria-label="Toggle navigation">
                          <i className="fas fa-bars" style={{fontSize: 30, color: "#eee"}}/>
                      </button>
                      <div className="collapse navbar-collapse" id="navbarSupportedContent">
                          <ul className="navbar-nav me-auto mb-2 mb-lg-0 menu clearfix">
{/*                              <li className="nav-item inline-block">
                                  <HashLink smooth to="/#">Home</HashLink>
                              </li>*/}
                              <li className="inline-block">
                                  <HashLink smooth to="/#section-trailer">Trailer</HashLink>
                              </li>
                              <li className="inline-block">
                                  <HashLink smooth to="/#section-gallery">Gallery</HashLink>
                              </li>
                              <li className="inline-block">
                                  <HashLink smooth to="/#section-news">News</HashLink>
                              </li>
                              <li className="inline-block">
                                  <HashLink smooth to="/#section-features">Features</HashLink>
                              </li>
                              <li className="inline-block">
                                  <HashLink smooth to="/#section-music">Music</HashLink>
                              </li>
                              <li className="inline-block">
                                  <HashLink smooth to="/#section-characters">Characters</HashLink>
                              </li>
                              <li className="inline-block">
                                  <HashLink smooth to="/#section-faq">Faq</HashLink>
                              </li>
                              <li className="inline-block">
                                  <HashLink smooth to="/#section-team">Team</HashLink>
                              </li>
{/*                              <li className="inline-block">
                                  <a href="https://drive.google.com/drive/folders/1lYecnNtt1BxwGfO_G2lgQRmF9dCFfd-g"
                                     target="_blank">Press</a>
                              </li>*/}
                          </ul>
                      </div>
                  </div>
              </nav>
              <div className="box box--social-links">
                  <div style={{flexBasis: '50%'}}/>
                  <div style={{width: '32rem'}}/>
                  <div className="sl-social bg-white-social">
                      <div className="d-none d-lg-flex">Join us</div>
                      <a href="https://discord.gg/hZnKPSYErr" target="_blank" className="social">
                          <i className="fa-brands fa-discord color-3"></i>
                      </a>
                  </div>
              </div>
          </header>
      </div>
  );
}

const Faq = () => {
    return (
        <section id="section-faq" className="faq ptb150">
            <div className="container">
                <div className="row">
                    <div className="title-bl text-center wow fadeIn" data-wow-duration="2s">
                        <div className="title color-white">
                            Frequently Asked Questions
                        </div>
                        <div className="subtitle">
                            Edward will help you to find out
                        </div>
                    </div>
                    <div className="mt30 text-center">
                        All questions and answers about Atomic Age and its Development. This list is not complete we
                        will attend more during time
                    </div>
                </div>
                <div className="row">
                    <div className="faq-container mt90">
                        <div className="row">
                            <div className="left-column-1 column col-lg-6 col-md-12">
                                <div className="table">
                                    <div className="table-row">
                                        <div className="counter-round table-cell valign-top">
                                            <div className="counter-bl">
                                                01
                                            </div>
                                        </div>
                                        <div className="counter-content table-cell valign-top">
                                            <div className="counter-title">Who is developing Atomic Age?</div>
                                            <div className="counter-text mt25">
                                                Atomic Age will be developed by a team of four people, located in
                                                Europe.
                                                Jill Peeters Art Director, Matthias Huber Producer, Chris
                                                Kohler Audio Engineer and Christian Staffa Technical Director.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="right-column-2 column col-lg-6 col-md-12">
                                <div className="table">
                                    <div className="table-row">
                                        <div className="counter-content table-cell valign-top text-right">
                                            <div className="counter-title">What is the origin of Atomic Age?</div>
                                            <div className="counter-text mt25">
                                                Well i would say my first idea was rising on a holiday trip to spain,
                                                thinking about a crazy cabaret stage standing in front of a colosseum.
                                            </div>
                                        </div>
                                        <div className="counter-round table-cell valign-top">
                                            <div className="counter-bl">
                                                02
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="left-column-1 column col-lg-6 col-md-12">
                                <div className="table">
                                    <div className="table-row">
                                        <div className="counter-round table-cell valign-top">
                                            <div className="counter-bl">
                                                03
                                            </div>
                                        </div>
                                        <div className="counter-content table-cell valign-top">
                                            <div className="counter-title">Which Platform will Atomic Age support?</div>
                                            <div className="counter-text mt25">
                                                First target will be to release Atomic Age on Windows, Linux and MacOS,
                                                but we
                                                think about a Nintendo Switch port after post-release.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="right-column-2 column col-lg-6 col-md-12">
                                <div className="table">
                                    <div className="table-row">
                                        <div className="counter-content table-cell valign-top text-right">
                                            <div className="counter-title">What languages will Atomic Age support?</div>
                                            <div className="counter-text mt25">
                                                We are happy that we can confirm that Atomic Age will be playable in
                                                English and German.
                                                We are not sure if we could provide german voice lines.
                                            </div>
                                        </div>
                                        <div className="counter-round table-cell valign-top">
                                            <div className="counter-bl">
                                                04
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="left-column-3 column col-lg-6 col-md-12">
                                <div className="table">
                                    <div className="table-row">
                                        <div className="counter-round table-cell valign-top">
                                            <div className="counter-bl">
                                                05
                                            </div>
                                        </div>
                                        <div className="counter-content table-cell valign-top">
                                            <div className="counter-title">When will Atomic Age will be released?</div>
                                            <div className="counter-text mt25">
                                                We are working on a playable Demo for Atomic Age. The Demo should be hopefully available mid 2025.
                                                After that we are targeting the final release 2026, please enter our <a href="https://discord.gg/hZnKPSYErr" target="_blank">discord
                                                channel</a> and <a href="https://store.steampowered.com/app/3774800/Atomic_Age" target="_blank">steam page</a> to get all relevant updates.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="right-column-4 column col-lg-6 col-md-12">
                                <div className="table">
                                    <div className="table-row">
                                        <div className="counter-content table-cell valign-top text-right">
                                            <div className="counter-title">How can i support Atomic Age?</div>
                                            <div className="counter-text mt25">
                                                One of best ways would be to wishlist it on Steam.
                                                Steam Page is currently under development and coming soon. We currently
                                                searching somebody who help us doing any public related parts.
                                                If you are interested please get in touch with us <a href="mailto:mail@atomicage.app">Contact</a>
                                            </div>
                                        </div>
                                        <div className="counter-round table-cell valign-top">
                                            <div className="counter-bl">
                                                06
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

const Features = () => {
    return (
        <section id="section-features" className="features ptb150 pb160 position-relative">
            <div className="container">
                <div className="row">
                    <div className="title-bl text-center wow fadeIn" data-wow-duration="2s">
                        <div className="title color-white">
                            Features
                        </div>
                        <div className="subtitle">
                            Cool things you can expect
                        </div>
                    </div>
                    <div className="mt30 text-center">
                        Solve a variety of puzzles, gather clues, and piece together the mystery behind the secrets of
                        atomic age
                    </div>
                </div>
                <div className="row pt25 g-0">
                    <div className="col-xxl-6 col-xl-12">
                        <ul className="list-1">
                            <li className="color2">Interact with objects, characters, and locations by clicking on
                                them
                            </li>
                            <li className="color2">Collect and manage items that can be used to solve puzzles</li>
                            <li className="color2">Optional hint system to give the player a next possible suggestion
                            </li>
                            <li className="color2">Extended language support German and English</li>
                            <li className="color2">A compelling narrative gameplay, filled with twists and mysteries
                            </li>
                            <li className="color2">Inventory, Logic and Environment based puzzle types</li>

                        </ul>
                    </div>
                    <div className="col-xxl-6 col-xl-12">
                        <ul className="list-1">
                            <li className="color2">Auto-safe system to rejoin the game without losing progress</li>
                            <li className="color2">Hand-drawn artwork with detailed backgrounds and character sprites</li>
                            <li className="color2">Hand rigged animations in Spine2D for character movement</li>
                            <li className="color2">Voice acting to enhance character development and immersion</li>
                            <li className="color2">Jazz inspired atmospheric soundtrack</li>
                            <li className="color2">Animated or illustrated story scenes to advance the plot</li>
                        </ul>
                    </div>
                    {/*                    <div className="col-xxl-2 col-xl-12 text-center">
                        <img src={CollinFeatures} style={{ width: 200 }} />
                    </div>*/}
                </div>
            </div>
        </section>
    );
}

const Characters = () => {
    return (
        <section id="section-characters" className="character blog-section ptb150">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="title-bl text-center wow fadeIn" data-wow-duration="2s">
                            <div className="title color-white">
                                Main Characters
                            </div>
                            <div className="subtitle">
                                Get in touch with the characters
                            </div>
                        </div>
                        <div className="title-description mt30 fweight-300 text-center">
                            Let us introduce the main characters of Atomic Age. Each one is uniquely designed by hand and has a distinct personality. There are even more to discover, lets meet them at the stage.
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-wrapper each-element mt90 clearfix">
                <div className="container">
                    <div className="row">
                        <div className="item col-xl-4 col-lg-12 mb20">
                            <div className="character--image">
                                <img src={CharacterEdward} />
                            </div>
                            <div className="item-info equal-height character-body">
                                <div className="item-title mt20" data-trim="40">Edward</div>
                                <div className="item-text mt25 lheight-30" data-trim="130">
                                    Edward, a struggling actor, arrives at Atomic Age cabaret for a job interview but he suddenly stumbles into a crime scene. As he gets caught up in the mystery, he unexpectedly finds love and a loyal best friend. Using his wit, charm, and acting skills, he must uncover the truth while navigating the cabaret’s secrets. Will this stage lead him to fame, romance, or danger?
                                </div>
                            </div>
                        </div>
                        <div className="item col-xl-4 col-lg-12 mb20">
                            <div className="character--image">
                                <img src={CharacterMia} />
                            </div>
                            <div className="item-info equal-height character-body">
                                <div className="item-title mt20" data-trim="40">Mia</div>
                                <div className="item-text mt25 lheight-30" data-trim="130">
                                    Mia is a sharp-witted, resourceful woman who effortlessly blends into her role as an actress on the small theater stage. On the surface, she’s charming, confident, and driven, but in reality, she’s a skilled secret agent with a keen eye for detail. Her natural instinct for observation and deduction makes her a formidable investigator, always staying one step ahead.
                                </div>
                            </div>
                        </div>
                        <div className="item col-xl-4 col-lg-12">
                            <div className="character--image">
                                <img src={CharacterVictoria} style={{paddingTop: 10}} />
                            </div>
                            <div className="item-info equal-height character-body">
                                <div className="item-title mt20" data-trim="40">Victoria</div>
                                <div className="item-text mt25 lheight-30" data-trim="130">
                                    Victoria, the warmhearted and charismatic seamstress of the small theater, lives for retro music and the golden glow of cabaret. She is intelligent, but in a pleasantly leisurely way—she would rather relax to a nostalgic song than deal with business matters.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row d-flex justify-content-center">
                        <div className="item col-xl-6 col-lg-12">
                            <div className="character--image">
                                <img src={CharacterHector} style={{paddingTop: 10}} />
                            </div>
                            <div className="item-info equal-height character-body">
                                <div className="item-title mt20" data-trim="40">Hector</div>
                                <div className="item-text mt25 lheight-30" data-trim="130">
                                    Hector Tansley is the tough yet magnetic owner of the small theater Atomic Age, a man whose life revolves around order and precision. Every application, every approval passes through his desk. But behind the star exterior beats the heart of a devoted collector of “Old Tech” from the 20th century, with a particular obsession for hulking, nostalgic robots—machines that carry stories of a world long past.
                                </div>
                            </div>
                        </div>
                        <div className="item col-xl-6 col-lg-12">
                            <div className="character--image" style={{height: 320, display: "flex", alignItems: "end", justifyContent: "center"}}>
                                <img src={CharacterNumber4} style={{paddingTop: 10, height: 250}} />
                            </div>
                            <div className="item-info equal-height character-body">
                                <div className="item-title mt20" data-trim="40">Number4</div>
                                <div className="item-text mt25 lheight-30" data-trim="130">
                                    Number 4 is a Category 4 personal assistant helping actors. A relic of a bygone era, a technology that vanished with the 21st century. Now a rare and precious find, this small robot is designed to play a important role in the game’s storyline. Stripped of its memory, Number 4 embarks on a journey to recover its lost parts, uncovering secrets that could change everything.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="row mb30 gx-4">
                    <div className="col-lg-3 col-md-12">
                        <a href="#">
                            <img src={Logo} width={290} alt="" />
                        </a>
                    </div>
                    <div className="col-lg-5 col-md-12 text-right">
                        <ul className="footer-menu">
                            <li>
                                <a href="/#">
                                    Home
                                </a>
                            </li>
                            <li>
                                <a href="https://drive.google.com/drive/folders/1lYecnNtt1BxwGfO_G2lgQRmF9dCFfd-g" target="_blank">
                                    Press
                                </a>
                            </li>
                            <li>
                                <a href="mailto:mail@atomicage.app">
                                    Contact
                                </a>
                            </li>
                        </ul>
                        <div className="social-content mt20">
                            <div className="social-list">
                                <a href="https://discord.gg/hZnKPSYErr" target="_blank">
                                    <i className="fa-brands fa-discord" aria-hidden="true"></i>
                                </a>
                            </div>
                        </div>
                        <div className="mt20">
                            financially supported by FFF Bayern and the budgetary funds of the Free State of
                            Bavaria
                        </div>

                    </div>
                    <div className="col-lg-4 col-md-12">
                        <a href="https://www.fff-bayern.de/foerderbereiche/games/" target="_blank"><div className="supporter supporter-fff"/></a>
                        <a href="https://www.stmd.bayern.de/" target="_blank"><div className="supporter supporter-government" /></a>
                    </div>
                </div>
                <div className="row">
                    <div className="copyright ptb30 d-flex">
                        <div className="col-6 text-start">
                            © Copyright {new Date().getFullYear()}
                        </div>
                        <div className="col-6 text-end">
                            All Rights Reserved
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

const Gallery = () => {
    const [index, setIndex] = useState(-1);

    const photos = [
        { src: AtomicAgeScreenshotDialogue2, height: 1080, width: 1920, description: "Dialogue system with voice over" },
        { src: AtomicAgeScreenshotDialogue1, height: 1080, width: 1920, description: "Narrative driven dialogues" },
        { src: AtomicAgeScreenshotInventory1, height: 1080, width: 1920, description: "You're able to combine objects in your inventory as well as in the scene" },
        { src: AtomicAgeScreenshotInventory2, height: 1080, width: 1920, description: "You get hints by examining items" },
        { src: AtomicAgeScreenshotObjectInteraction1, height: 1080, width: 1920, description: "Several objects you can interact with" },
        { src: AtomicAgeScreenshotTitleScreen, height: 1080, width: 1920, description: "This is the game and stage entrance of Atomic Age" },
        { src: AtomicAgeScreenshotStage, height: 1080, width: 1920, description: "Cabaret stage scene of Atomic Age"},
        { src: AtomicAgeMap, height: 1080, width: 1920, description: "Top down map of the whole cabaret stage Atomic Age"},
    ];

    return (
        <section id="section-gallery" className="gallery ptb150 position-relative">
            <div className="container">
                <div className="row">
                    <div className="title-bl text-center wow fadeIn" data-wow-duration="2s">
                        <div className="title color-white">
                            Gallery
                        </div>
                        <div className="subtitle">
                            The actors hope you like it
                        </div>
                    </div>
                    <div className="mt30 text-center">
                        Get your first impression how Atomic Age will look like. We hope you like our work and we will appreciate to so see you at our discord channel in person.
                    </div>
                </div>
                <div className="row mt25">
                    <ColumnsPhotoAlbum
                        onClick={({ index }) => setIndex(index)}
                        photos={photos}
                        padding={12}
            /*            targetRowHeight={150}
                        rowConstraints={{ singleRowMaxHeight: 350 }}*/
                        columns={(containerWidth) => {
                            if (containerWidth < 768) return 1;
                            return 3;
                        }}
                        componentsProps={() => ({
                            image: { className: "image" },
                        })}
                    />
                    <Lightbox
                        plugins={[Captions, Zoom]}
                        captions={{ descriptionTextAlign: "center" }}
                        slides={photos}
                        open={index >= 0}
                        index={index}
                        close={() => setIndex(-1)}
                    />
                </div>
            </div>
        </section>
    );
}

const MinimalSoundCloudPlayer = ({ trackUrl }: { trackUrl: string | number | boolean }) => {
    const embedUrl = `https://w.soundcloud.com/player/?url=${encodeURIComponent(
        trackUrl
    )}&color=%23f95f86&auto_play=false&hide_related=true&show_comments=false&show_user=false&show_reposts=false&visual=false`;

    return (
        <iframe
            title="SoundCloud Player"
            width="100%"
            height="120"
            scrolling="no"
            frameBorder="no"
            allow="autoplay"
            src={embedUrl}
            style={{ borderRadius: '8px', overflow: 'hidden', zIndex: 1, position: "relative" }}
        />
    );
};

const Music = () => {
    return (
        <section id="section-music" className="music ptb150 position-relative">
            <div className="container">
                <div className="row">
                    <div className="title-bl text-center wow fadeIn" data-wow-duration="2s">
                        <div className="title color-white">
                            Music
                        </div>
                        <div className="subtitle">
                            Atomic Age Original Soundtrack
                        </div>
                    </div>
                    <div className="mt30 text-center">
                        The Atomic Age Jazz and Swing inspired Original Soundtrack composed by Chris Kohler
                    </div>
                </div>
                <div className="row pt25 g-5">
                    <div className="col-xxl-6 col-xl-12">
                        <MinimalSoundCloudPlayer trackUrl="https://soundcloud.com/user-588374177/atomic-age-main-title" />
                    </div>
                    <div className="col-xxl-6 col-xl-12">
                        <MinimalSoundCloudPlayer trackUrl="https://soundcloud.com/user-588374177/atomig-age-backoffice" />
                    </div>
                </div>
                <div className="row pt25 d-flex justify-content-center">
                    <div className="col-xl-6">
                        <MinimalSoundCloudPlayer trackUrl="https://soundcloud.com/user-588374177/atomic-age-stage" />
                    </div>
                </div>
            </div>
        </section>
    );
}

const Team = () => {
    return (
        <section id="section-team" className="team-bl ptb150">
            <div className="container">
                <div className="row">
                    <div className="title-bl text-center wow fadeIn" data-wow-duration="2s">
                        <div className="title color-white">
                            Team
                        </div>
                        <div className="subtitle">
                            The amazing team behind the stage
                        </div>
                    </div>
                    <div className="mt30 text-center">
                        Meet the team behind Atomic Age
                    </div>
                </div>
                <div className="d-flex flex-column align-items-center">
                    <div className="row mt60 justify-content-center" style={{maxWidth: "60rem"}}>
                        <div className="item-content first col-lg-4 col-md-12 mb30 equal-height">
                            <div className="border-img">
                                <img src={DesyTeam} />
                            </div>
                            <div className="text-container background-4 text-center">
                                <a href="#" className="name font-agency fsize-28 fweight-700 lheight-32 color-white">
                                    Matthias Huber
                                </a>
                                <div className="position mt10">
                                    Producer / Developer
                                </div>
                                <div className="social mt20">
                                    <a href="https://x.com/desytech" target="_blank">
                                        <i className="fa-brands fa-x-twitter" aria-hidden="true"></i>
                                    </a>
                                    <a href="https://www.twitch.tv/desytech" target="_blank">
                                        <i className="fa-brands fa-twitch" aria-hidden="true"></i>
                                    </a>
                                    <a href="https://www.linkedin.com/in/matthias-huber-6390562b5" target="_blank">
                                        <i className="fa-brands fa-linkedin" aria-hidden="true"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="item-content first col-lg-4 col-md-12 mb30 equal-height">
                            <div className="border-img">
                                <img src={JillTeam}/>
                            </div>
                            <div className="text-container background-4 text-center">
                                <a href="" className="name font-agency fsize-28 fweight-700 lheight-32 color-white">
                                    Jill Peeters
                                </a>
                                <div className="position mt10">
                                    Creative Director
                                </div>
                                <div className="social mt20">
                                    <a href="https://twitter.com/JillsArtStuff" target="_blank">
                                        <i className="fa-brands fa-twitter" aria-hidden="true"></i>
                                    </a>
                                    <a href="https://www.instagram.com/jillsartandstuff/?hl=en" target="_blank">
                                        <i className="fa-brands fa-instagram" aria-hidden="true"></i>
                                    </a>
                                    <a href="https://www.linkedin.com/in/jill-peeters-10298523a" target="_blank">
                                        <i className="fa-brands fa-linkedin" aria-hidden="true"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="item-content first col-lg-4 col-md-12 mb30 equal-height">
                            <div className="border-img">
                                <img src={ChrisTeam} />
                            </div>
                            <div className="text-container background-4 text-center">
                                <a href="" className="name font-agency fsize-28 fweight-700 lheight-32 color-white">
                                    Chris Kohler
                                </a>
                                <div className="position mt10">
                                    Audio Composer
                                </div>
                                <div className="social mt20">
                                    <a href="https://bsky.app/profile/chriskohler.net" target="_blank">
                                        <i className="fa-brands fa-twitter" aria-hidden="true"></i>
                                    </a>
                                    <a href="https://www.linkedin.com/in/chriskohlermusic" target="_blank">
                                        <i className="fa-brands fa-linkedin" aria-hidden="true"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="item-content first col-lg-4 col-md-12 mb30 equal-height">
                            <div className="border-img">
                                <img src={CameronTeam} />
                            </div>
                            <div className="text-container background-4 text-center">
                                <a href="" className="name font-agency fsize-28 fweight-700 lheight-32 color-white">
                                    Cameron Guile
                                </a>
                                <div className="position mt10">
                                    Story Writer / Voice Actor
                                </div>
                                <div className="social mt20">
                                    <a href="https://www.instagram.com/mill_combo" target="_blank">
                                        <i className="fa-brands fa-instagram" aria-hidden="true"></i>
                                    </a>
                                    <a href="https://www.linkedin.com/in/cameron-guile-566806166" target="_blank">
                                        <i className="fa-brands fa-linkedin" aria-hidden="true"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="item-content first col-lg-4 col-md-12 mb30 equal-height">
                            <div className="border-img">
                                <img style={{objectPosition: "0px -35px"}} src={MaksTeam} />
                            </div>
                            <div className="text-container background-4 text-center">
                                <a href="" className="name font-agency fsize-28 fweight-700 lheight-32 color-white">
                                    Maksym Chentai
                                </a>
                                <div className="position mt10">
                                    Spine Animator
                                </div>
                                <div className="social mt20">
                                    <a href="https://bsky.app/profile/chriskohler.net" target="_blank">
                                        <i className="fa-brands fa-behance" aria-hidden="true"></i>
                                    </a>
                                    <a href="https://www.linkedin.com/in/maksym-chentai-2817a2323" target="_blank">
                                        <i className="fa-brands fa-linkedin" aria-hidden="true"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="item-content first col-lg-4 col-md-12 mb30 equal-height">
                            <div className="border-img">
                                <img src={StaffaTeam} />
                            </div>
                            <div className="text-container background-4 text-center">
                                <a href="" className="name font-agency fsize-28 fweight-700 lheight-32 color-white">
                                    Christian Staffa
                                </a>
                                <div className="position mt10">
                                    Technical Director
                                </div>
                                <div className="social mt20">
                                    <a href="https://www.linkedin.com/in/christian-staffa-54b4076b" target="_blank">
                                        <i className="fa-brands fa-linkedin" aria-hidden="true"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

const Trailer = () => {
    return (
        <section id="section-trailer" className="section trailer ptb150 position-relative">
            <div className="container">
                <div className="row">
                    <div className="title-bl text-center wow fadeIn" data-wow-duration="2s">
                        <div className="title color-white">
                            Trailer
                        </div>
                        <div className="subtitle">
                            What is the game about
                        </div>
                    </div>
                    <div className="mt30 text-center">
                        This trailer will give you a short overview of several features of Atomic Age. It concentrate art style, voice acting, game mechanics and give you a short introduction into the current look and feel of the game.
                    </div>
                        <div className="image mt25" style={{ width: "100%", height: "auto", padding: 4 }}>
                            <ReactPlayer
                                src='https://youtu.be/gK-XiL5ptOc'
                                style={{ width: '100%', height: "100%", aspectRatio: '16/9' }}
                                controls
                                // playing
                                // muted
                                light={<img style={{width: "100%", height: "100%", borderRadius: 6 }} src={TrailerImage} alt='TrailerThumbnail' />}
                            />
                        </div>
                </div>
            </div>
        </section>
    );
}

const About = () => {
    return (
        <section id="section-home" className='section headline'>
            <div className="box box--about">
                <div>
                    <div>
                        <h3>About the game</h3>
                        <p style={{lineHeight: "42px", fontSize: 22}}>
                            Welcome to the one and only place for carbon city's retro and nostalgic fans the cabaret
                            stage Atomic Age.
                            A retro-futuristic, slapstick based 2D point & click adventure in the shape of the 50th
                            and 60th years.
                            The mysterious death of William, the former owner of the cabaret stage, still remains in Carbon City.
                            Fortunately, an old family friend Hektor, immediately takes over the daily operations and sets new accents with a grand opening show.
                            A perfect opportunity for actor Edward to launch his big breakthrough.
                            A turbulent adventure begins. Will Edward and his friends unravel the mysteries behind the Atomic Age and protect William’s legacy?
                        </p>
                    </div>
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                        <a href="https://store.steampowered.com/app/3774800/Atomic_Age" target="_blank" className='cta-button cta-button-steam'/>
                    </div>
                    <img src={MiaAbout}/>
                </div>
            </div>
        </section>
    );
}

const SteamNewsWrapper = () => {
    return (
        <section id="section-news" className="news blog-section ptb150">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="title-bl text-center wow fadeIn" data-wow-duration="2s">
                            <div className="title color-white">
                                Latest News
                            </div>
                            <div className="subtitle">
                                Keep you updated
                            </div>
                        </div>
                        <div className="title-description mt30 fweight-300 text-center">
                            Be always informed about the development behind Atomic Age. Here you will find the latest six news from Steam Community Hub.
                        </div>
                    </div>
                </div>
            </div>
            <SteamNews />
        </section>
    );
}

const App = () => {

    useEffect(() => {
        const onHashChange = () => {
            ReactGA.send({hitType: "pageview", page: window.location.pathname + window.location.search + window.location.hash, title: "Page View" });
        }
        window.addEventListener('hashchange', onHashChange);
        onHashChange();

        return () => {
            window.removeEventListener('hashchange', onHashChange);
        };

    }, [])

    return (
        <React.Fragment>
            <Header/>
            <div className="background-image"></div>
            <div className="overlay"></div>
            <About />
            <Trailer />
            <Gallery />
            <SteamNewsWrapper />
            <Features />
            <Music />
            <Characters />
            <Faq />
            <Team />
            <Footer />
        </React.Fragment>
    );
}

export default App;
